<template>
    <div id="wrapper" :key="valuekey">
        <div class="row">
            <div class="col-xl-12">
                <div class="card-box">
                    <div class="form-row">
                        <div class="col-md-11">
                            <h4 class="header-title mb-4">
                                <h4 class="page-title">{{ $t('string.msg.menu.banner.list.title') }}</h4>
                            </h4>
                        </div>
                        <div class="col-md-1" v-if="items">
                            <h4 class="text-center">{{ $t('str.total') }}</h4>
                            <h4 class="text-center" style="color: grey">{{ items.length }}</h4>
                        </div>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-centered table-hover mb-0" id="datatable">
                            <thead>
                                <tr>
                                    <th class="border-top-0">{{ $t('string.msg.banner.table.header.name') }}</th>
                                    <th class="border-top-0">{{ $t('string.msg.banner.table.header.date') }}</th>
                                    <th class="border-top-0">{{ $t('string.msg.banner.table.header.status') }}</th>
                                    <th class="border-top-0">{{ $t('string.msg.banner.table.header.photo') }}</th>
                                    <th class="border-top-0">{{ $t('string.msg.banner.table.header.time') }}</th>
                                    <th class="border-top-0">{{ $t('string.msg.banner.table.header.priority') }}</th>
                                </tr>
                            </thead>
                            <tbody v-bind:key="item._id" v-for="item in items" class="cursor-pointer"
                                @click="selectItem(item)">
                                <tr v-if="item.status == 'ACTIVE'">
                                    <td>
                                        <span>
                                            {{ camelize(item.company) }}
                                        </span>
                                    </td>
                                    <td>
                                        <span>
                                            {{ new Date(item.date).toLocaleDateString() }}
                                        </span>
                                    </td>
                                    <td>
                                        <span>
                                            {{ $t(item.status) }}
                                        </span>
                                    </td>
                                    <td>
                                        <span>
                                            <!-- <img v-if="item.bannerURL" v-bind:src="`${domain}${item.bannerURL}`" alt="image" height="100" width="400" /> -->
                                            <img v-if="item.bannerURL" v-bind:src="item.bannerURL" alt="image" height="100"
                                                width="400" />
                                        </span>
                                    </td>
                                    <td>
                                        <span>
                                            {{ camelize(item.time) }}
                                        </span>
                                    </td>
                                    <td>
                                        <span>
                                            {{ camelize(item.priority) }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Controller from './CrtListBanner'
export default {
    name: 'ListBanner',
    props: ['valuekey'],
    watch: {
        valuekey() { },
    },
    components: {},
    data() {
        return {
            errors: [],
            titleToast: null,
            messageToast: null,
            messageIdToast: null,
            items: [],
            item: {},
            filters: {
                cnhCategory: null,
                additionalCourse: null,
            },
            newTrucker: false,
            totalCurriculums: 0,
        }
    },
    methods: Controller.methods,
    created() {
        Controller.init(this)
    },
    mounted() { },
}
</script>


